import React, {useEffect} from 'react';
import {GlobalStyles} from 'globalStyles';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import ActivateAccount from 'components/ActivateAccount';
import NotFound from 'components/NotFound';
import Map from 'components/Map';
import NewPassword from 'components/NewPassword';
import Info from 'components/Info';
import {ToastContainer} from 'react-toastify';
import queryString from 'query-string';
import i18next from 'i18next';

function App() {

  useEffect(() => {
    const currentLang = localStorage.getItem('lang') || 'en';

    if (window.location.pathname === '/map') {
      const browserLang = window.navigator.userLanguage || window.navigator.language;
      localStorage.setItem('lang', browserLang);
      i18next.changeLanguage(browserLang);
    } else {
      const query = queryString.parse(window.location.search);
      const lang = query && query.lang ? query.lang : currentLang;
      localStorage.setItem('lang', lang);
  
      i18next.changeLanguage(lang);
    }
  }, []);

  return (
    <>
      <GlobalStyles />
      <ToastContainer className="ISSToast" />
      <BrowserRouter>
        <Routes>
          <Route path="/activate" element={<ActivateAccount />} />
          <Route path="/map" element={<Map />} />
          <Route path="/not-found" element={<NotFound />} />
          <Route path="/reset-password" element={<NewPassword />} />
          <Route path="/info" element={<Info />} />
          <Route path="*" element={<Navigate to="/not-found" replace />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
